import React from 'react';
export function Products() {
  const ebooks = [{
    title: 'Guía Completa de Picadas Fáciles',
    description: '+80 ideas económicas | Recetas express | Tips pro',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/73uE73Bjg7tN2Cbgdd9sgZ/imagen_actualizada_guia_commpleta.png'
  }, {
    title: 'Checklist de Compras Inteligente',
    description: 'Cantidades exactas por persona | Alternativas low-cost',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pBprwidn6FdRPiSMa7QBCm/bono_1_imagen_actualizada.png'
  }, {
    title: 'Recetario Premium de Dips & Untables',
    description: 'Desde hummus clásico hasta salsas secretas',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/41QopE7DA9xZgvRGaY28uB/bono_2_imagen_actualizada.png'
  }, {
    title: 'Calendario de Picadas (30 días)',
    description: 'Temáticas para cada ocasión: fútbol, familia, gourmet',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8t6NB8apAW7VUXLYWELY7R/bono_3_imagen_actualizada.png'
  }];
  const bonuses = ['Pablos & Mariscos Gourmet', 'Maridajes que impresionan', 'Cómo convertirte en anfitriona rentable', 'Calculadora de costos y lista editable', 'Los 20 bocadillos más buscados', 'Combo Express de finger foods'];
  return;
}